export const getQuickLinkId = (title: string) =>
  encodeURIComponent(title.toLowerCase().replace(/\s/g, '-'));
